const tooltips = {
  penzugy: 'Rendszerben használatos fizetési módok és pénznem adatok rögzítésére szolgáló felület.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
